import { render } from "./App.vue?vue&type=template&id=1c9db51e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1c9db51e&lang=css"

import exportComponent from "C:\\Users\\PCHOME\\projetos2022\\live-chat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__